var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 0c-.883 0-1.6.705-1.6 1.571v6.286h1.6V1.571h9.6v6.286h1.6V1.571C14.4.705 13.683 0 12.8 0H3.2zM.48 8.643a.476.476 0 0 0-.48.471C0 10.155.86 11 1.92 11h12.16c1.06 0 1.92-.845 1.92-1.886a.476.476 0 0 0-.48-.471H.48z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.72ec3866381eced553ee3a273dfdd254.svg";
export { ForwardRef as ReactComponent };